import { RefObject, useEffect, useRef, useState } from 'react'

/** @deprecated Prefer CSS `:hover` instead of JS-based hover detection. */
export function useHover<T extends Element>(): [RefObject<T | null>, boolean] {
  const [value, setValue] = useState(false)

  const ref = useRef<T>(null)

  const handleMouseOver = () => setValue(true)
  const handleMouseOut = () => setValue(false)

  useEffect(
    () => {
      const node = ref.current
      if (node) {
        node.addEventListener('mouseenter', handleMouseOver)
        node.addEventListener('mouseleave', handleMouseOut)

        return () => {
          node.removeEventListener('mouseenter', handleMouseOver)
          node.removeEventListener('mouseleave', handleMouseOut)
        }
      }
    },
    // oxlint-disable-next-line react-hooks/exhaustive-deps
    [ref.current] // Recall only if ref changes
  )

  return [ref, value]
}
